<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Edit Handback Reason</cll-dialog-title>
        <cll-dialog-subtitle>{{ handbackReason.name }}</cll-dialog-subtitle>
    </cll-dialog-header>
    @if (handbackReasonFormGroup) {
        <div [formGroup]="handbackReasonFormGroup">
            <div class="dialog-container">
                <div class="dialog-detail">
                    <div class="dialog-container-header">
                        <cll-icon type="outlined" [size]="24">info</cll-icon>
                        <span class="dialog-container-header-text">Details</span>
                    </div>
                    <cll-form-field label="Name">
                        <input cllFormInput type="text"
                               [formControl]="handbackReasonFormGroup.controls.name">
                    </cll-form-field>
                    <cll-form-field label="Description">
                <textarea cllFormInput type="text"
                          [formControl]="handbackReasonFormGroup.controls.description"></textarea>
                    </cll-form-field>
                </div>
            </div>
            <span class="dialog-divider"></span>
            @if (updateHandbackReason.error(); as error) {
                <app-error-panel [error]="error" />
            }
            <cll-dialog-footer>
                <button cll-button
                        colour="variant"
                        cllDialogClose>
                    Cancel
                </button>
                <button cll-filled-button
                        colour="secondary"
                        [disabled]="handbackReasonFormGroup.invalid || this.updateHandbackReason.loading()"
                        (click)="update()">
                    Save
                </button>
            </cll-dialog-footer>
        </div>
    }
</cll-dialog-layout>
